import { getAxios } from './apiUtils';

export const get = async page => {
  try {
    const { data } = await getAxios().get('/api/photos', { params: { take: 50, page } });
    // console.log(result);
    return { photos: data[0], count: data[1] };
  } catch (error) {
    throw new Error(error.message);
  }
};
export const getById = async id => {
  try {
    const { data } = await getAxios().get('/api/photos/' + id);
    return data;
  } catch (error) {
    throw new Error(error.message);
  }
};
export const getUsers = async () => {
  try {
    const { data } = await getAxios().get('/api/photos/users');
    return data;
  } catch (error) {
    throw new Error(error.message);
  }
};
export const search = async query => {
  try {
    const { data } = await getAxios().get('/api/photos/search', { params: query });
    return { photos: data[0], count: data[1] };
  } catch (error) {
    throw new Error(error.message);
  }
};
export const add = async photo => {
  try {
    return await getAxios().post('/api/photos/', photo);
  } catch (error) {
    throw new Error(error.message);
  }
};
export const update = async photo => {
  try {
    return await getAxios().put('/api/photos/', photo);
  } catch (error) {
    throw new Error(error.message);
  }
};
